// @ts-nocheck
/**
 * miscMethods.ts
 * その他のメソッド（ヘルプ、共有、ズーム、測位、スワイプ等）
 * App.vue から切り出し
 */

import { nextTick } from 'vue'

type VM = any

export function help() {
  window.open('https://sakura.3ku.jp/gis/oh3-reversedictionary/', '_blank')
}

export function share(vm: VM) {
  const mapName = 'map01'
  const windowId = 'share-window-' + mapName
  const currentVisible = vm.$store.state.floatingWindows[windowId]
  if (currentVisible) {
    vm.$store.dispatch('hideFloatingWindow', windowId)
  } else {
    vm.$store.dispatch('showFloatingWindow', windowId)
  }
}

export function zoomIn(vm: VM) {
  const map = vm.$store.state.map01
  map.zoomIn({ duration: 500 })
}

export function zoomOut(vm: VM) {
  const map = vm.$store.state.map01
  map.zoomOut({ duration: 500 })
}

// サーバから現ジョブの点を取得して CSV ダウンロード
export async function downloadCsv2(vm: VM) {
  vm.$refs.jobPicker.downloadCsvForSokui()
}

// SIMA 出力
export async function exportCsv2Sima(vm: VM) {
  vm.$refs.jobPicker.downloadSimaForSokui()
}

// 単点/結線モードの切替
export function setLineMode(vm: VM, mode) {
  vm.$refs.jobPicker.setLineMode(mode)
}

// ジョブピッカーを開き、サーバ一覧を最新化
export async function openJobPicker(vm: VM) {
  vm.$store.state.isKuiuchi = false
  vm.isTracking = false
  vm.$store.state.isWatching = false
  vm.$store.dispatch('showFloatingWindow', 'job-picker')
  vm.isJobMenu = true
  // FloatingWindow内のコンポーネントがマウントされるまで待つ
  const waitForRef = () => new Promise<void>((resolve) => {
    let attempts = 0
    const check = () => {
      if (vm.$refs.jobPicker) {
        vm.$refs.jobPicker.openJobPicker()
        resolve()
      } else if (attempts++ < 50) {
        setTimeout(check, 50)
      } else {
        console.warn('[openJobPicker] $refs.jobPicker が取得できませんでした')
        resolve()
      }
    }
    check()
  })
  await waitForRef()
}

// マップ中央のゾーンから座標系ラベルを推定し store に反映
export function zahyoGet(vm: VM) {
  const map = vm.map01
  const center = map.getCenter()
  const centerPoint = map.project([center.lng, center.lat])
  const features = map.queryRenderedFeatures(centerPoint, { layers: ['zones-layer'] })
  if (features.length > 0) {
    const zoneFeature = features[0]
    const zone = zoneFeature.properties.zone
    vm.$store.state.zahyokei = '公共座標' + zone + '系'
  } else {
    vm.$store.state.zahyokei = ''
  }
}

export function startTorokuHere(vm: VM) {
  vm.$refs.jobPicker.startTorokuHere()
}

// ジョブ終了処理（クリーンアップ含む）
export function onJobEndClick(vm: VM, isCleanup) {
  vm.$refs.jobPicker.onJobEndClick()
  vm.isJobMenu = false
  if (isCleanup) {
    vm.jobPickerOpen = false
    vm.isJobMenu = false
    vm.$store.dispatch('hideFloatingWindow', 'job-picker')
  }
}

// AI画像鮮明化 — FloatingWindowを開く
export function onAiEnhance(vm: VM) {
  vm.$store.dispatch('showFloatingWindow', 'ai-enhance-dialog')
}

// ESCキーでスワイプモードと2画面モードの両方を終了（アニメーション付き）
export function exitSwipeAndSplit(vm: VM) {
  // 境界線を右にアニメーション
  const animate = () => {
    if (vm.swipePosition < 100) {
      vm.swipePosition = Math.min(100, vm.swipePosition + 5)
      requestAnimationFrame(animate)
    } else {
      // アニメーション完了後に1画面モードに
      vm.swipeMode = false
      vm.mapSyncMaster = 'map01'
      vm.disableSwipeFollow()
      vm.disableSwipeNudge()
      vm.disableSwipeManualPan()
      vm.setMapInteractions(vm.$store.state.map01, true)
      vm.setMapInteractions(vm.$store.state.map02, true)
      vm.stopMapSync()
      vm.forceEnableMapInteractions(vm.$store.state.map01)
      vm.forceEnableMapInteractions(vm.$store.state.map02)
      vm.s_map2Flg = false
      vm.mapSize.map01.width = '100%'
      vm.mapSize.map01.height = '100%'
      vm.mapSize.map02.width = '50%'
      vm.mapSize.map02.height = '100%'
      vm.mapSize.map02.top = 0
      vm.mapSize.map02.right = 0
      vm.$nextTick(() => {
        vm.setMapInteractions(vm.$store.state.map01, true)
        vm.setMapInteractions(vm.$store.state.map02, true)
        vm.forceEnableMapInteractions(vm.$store.state.map01)
        vm.forceEnableMapInteractions(vm.$store.state.map02)
      })
    }
  }
  animate()
}

export function startSwipeDrag(vm: VM, e) {
  e.preventDefault()
  e.stopPropagation()
  const container = document.getElementById('map00')
  if (!container) return

  const onMove = (moveEvent) => {
    moveEvent.preventDefault()
    const clientX = moveEvent.touches ? moveEvent.touches[0].clientX : moveEvent.clientX
    const rect = container.getBoundingClientRect()
    const pos = ((clientX - rect.left) / rect.width) * 100
    vm.swipePosition = Math.max(0, Math.min(100, pos))
  }

  const onEnd = () => {
    document.removeEventListener('mousemove', onMove)
    document.removeEventListener('mouseup', onEnd)
    document.removeEventListener('touchmove', onMove, { passive: false })
    document.removeEventListener('touchend', onEnd)
  }

  document.addEventListener('mousemove', onMove)
  document.addEventListener('mouseup', onEnd)
  document.addEventListener('touchmove', onMove, { passive: false })
  document.addEventListener('touchend', onEnd)
}
